<template>
  <span class="svg-icon-menu-four-dot">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.55851 9.36702C8.10967 9.36702 9.36702 8.10961 9.36702 6.55851C9.36702 5.00741 8.10967 3.75 6.55851 3.75C5.00735 3.75 3.75 5.00741 3.75 6.55851C3.75 8.10961 5.00735 9.36702 6.55851 9.36702Z" :fill="color"/>
      <path d="M6.55851 20.25C8.10967 20.25 9.36702 18.9926 9.36702 17.4415C9.36702 15.8904 8.10967 14.633 6.55851 14.633C5.00735 14.633 3.75 15.8904 3.75 17.4415C3.75 18.9926 5.00735 20.25 6.55851 20.25Z" :fill="color"/>
      <path d="M20.25 6.55851C20.25 8.10961 18.9926 9.36702 17.4415 9.36702C15.8903 9.36702 14.633 8.10961 14.633 6.55851C14.633 5.00741 15.8903 3.75 17.4415 3.75C18.9926 3.75 20.25 5.00741 20.25 6.55851Z" :fill="color"/>
      <path d="M17.4415 20.25C18.9926 20.25 20.25 18.9926 20.25 17.4415C20.25 15.8904 18.9926 14.633 17.4415 14.633C15.8903 14.633 14.633 15.8904 14.633 17.4415C14.633 18.9926 15.8903 20.25 17.4415 20.25Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
